import React from "react"
import Link from './link'
import Image from "./image";
import PackageBannerImg from '../images/bannerMyPackage.jpg'
import PackageBannerPlaceholder from '../images/birthday-home-placeholder.png'

class PackageBanner extends React.Component {
  render() {
    let { isPackage, packageName, bannerPackageImage } = this.props
    let linkPage = 'package/package-list'

    if(isPackage){
      bannerPackageImage = PackageBannerImg
      linkPage = 'package/privilege-list'
    }

    return (
      <div className={`package-banner`}>
        <Link to={linkPage}>
          <div className="image-container">
            <Image
              src={bannerPackageImage}
              placeholder={PackageBannerPlaceholder}
              className="image-banner-package"
            />
            {isPackage && (
              <div className="overlay-text">
                {/* My Package : <b>{packageName}</b> */}
                {/* <b>{packageName}</b> */}
                  <b className="overlay-text-color">My Package 2025</b>
                  <br />
                  <b className="overlay-text-color">{packageName}</b>
              </div>
            )}
          </div>
        </Link>
      </div>
    )
  }
}

export default PackageBanner
